export const getQueryKeys = {
  transports: ({ clientId, houseId }) => ['transports', clientId, houseId],
  arrearTypes: ({ houseIds }) => ['arrearTypes', ...houseIds],
  arrearInfo: ({ houseIds }) => ['arrearInfo', ...houseIds],
  templates: ({ serviceCompanyId, registrationTypeId }) => [
    'templates',
    serviceCompanyId,
    registrationTypeId,
  ],
  companies: () => ['companies'],
  housingStock: (companyId, houseId) => ['housingStock', companyId, houseId],
  housingStockHouses: ({ companyId, streetId, houseId }) => [
    'housingStock/houses',
    companyId,
    streetId,
    houseId,
  ],
  flatStepLife: (stageLifeCircleRoomId) => [
    'flatStepLife',
    stageLifeCircleRoomId,
  ],
  flatsGrid: (houseId) => ['flatsGrid', houseId],
  houseAvailable: (houseId, currentCompanyId) => [
    'houseAvailable',
    houseId,
    currentCompanyId,
  ],
  flatAvailable: (houseId, currentCompanyId, flatId) => [
    'flatAvailable',
    houseId,
    currentCompanyId,
    flatId,
  ],
  flatsGridTemplates: () => 'flatsGridTemplates',
  flatAccounts: (addressId) => ['flatAccounts', addressId],
  flatComment: (addressId) => ['flatComment', addressId],
  flatMeters: (addressId) => ['flatMeters', addressId],
  flatAttachments: (addressId) => ['flatAttachments', addressId],
  houseAttachments: (houseId) => ['houseAttachments', houseId],
  houseHead: (houseId) => ['houseHead', houseId],
  houseBalance: (houseId) => ['houseBalance', houseId],
  houseComment: (houseId) => ['houseComment', houseId],
  houseInfo: (houseId) => ['houseInfo', houseId],
  houseStages: () => 'houseStages',
  housingStockRequests: (houseId, addressId) => [
    'housingStock/requests',
    houseId,
    addressId,
  ],
  housingStockExportTypes: () => 'housingStockExportTypes',
  housingStockExportFields: (exportTypeId) => [
    'housingStockExportFields',
    exportTypeId,
  ],
  housingStockExportFieldOptions: (optionsUrl) => [
    'housingStockExportFieldOptions',
    optionsUrl,
  ],
  awailableReports: () => 'awailableReports',
  accountTypes: () => 'accountTypes',
  request: (requestId) => ['request', requestId],
  addressStages: () => 'addressStages',
  acceptanceStages: () => 'acceptanceStages',
  houseAcceptanceInterval: () => 'houseAcceptanceInterval',
  acceptanceExecutors: () => 'acceptanceExecutors',
  housesWithCamera: (companyId) => ['housesWithCamera', companyId],
  houseCameras: (houseId) => ['houseCameras', houseId],
  flatMeterTypes: () => ['flatMeterTypes'],
  flatMeterStatuses: () => ['flatMeterStatuses'],
  flatMeterLocations: () => ['flatMeterLocations'],
  flatMeterAttachment: ({ meterId, fileName }) => [
    'flatMeterAttachment',
    meterId,
    fileName,
  ],
  flatMeterTariffs: () => ['flatMeterTariffs'],
  flatMetersAttachments: (meterId) => ['flatMetersAttachments', meterId],
  houseMeterStatuses: () => 'houseMeterStatuses',
  houseMeterTariffs: () => 'houseMeterTariffs',
  transportCountries: () => 'transportCountries',
  clientDocumentTypes: () => 'clientDocumentTypes',
  clientDocuments: (clientId) => ['clientDocuments', clientId],
  transportAttachments: (transportId) => ['transportAttachments', transportId],
  clientPassportInfo: (clientId) => ['clientPassportInfo', clientId],
  rsoDraft: (draftId) => ['rsoDraft', draftId],
  stagesLifeCirleByStage: (stageId) => ['stagesLifeCirleByStage', stageId],
  attachmentUrl: (requestId, fileName) => [
    'attachmentUrl',
    requestId,
    fileName,
  ],
  houseRequests: ({ houseId, addressStageRequest, targetDate }) => [
    'houseRequests',
    houseId,
    addressStageRequest,
    targetDate,
  ],
  roomStages: (addressId) => ['FlatsGrid/roomStages', addressId],
  roomSteps: (addressId) => ['FlatsGrid/roomSteps', addressId],
  awailableReportsAddress: () => ['awailableReportsAddress'],
};
